import React, { useState } from 'react';
import axios from 'axios';
import { Card } from '../../../../design-system';
import Alert from '../../../../helpers/alert';
import { successRefetch } from '../../../../helpers/data-loader';
import ModalForm from '../../../../components/ModalForm';
import {
  Table,
  TableCardHeader,
  TableBody as TableBodyBase,
} from '../../../../components/Table';
import { ERR_MSG } from '../../../../globalConstants';
import { GRANT_SOURCES_COLUMNS, GRANT_SOURCES_MODAL_FIELDS } from './constants';

const TableBody = TableBodyBase as React.ComponentType<any>;

interface FundingSourcesProps {
  data: any;
  clientId: any;
  refetch: () => void;
  canEdit: boolean;
}

const FundingSources = ({
  data,
  clientId,
  refetch,
  canEdit,
}: FundingSourcesProps) => {
  const [targetedFundingSource, setTargetedFundingSource] = useState<any>('');
  const [isOpenAddFundingSource, setIsOpenAddFundingSource] = useState(false);
  const [isOpenEditFundingSource, setIsOpenEditFundingSource] = useState(false);

  const toggleAddFundingSource = () => {
    setIsOpenAddFundingSource(!isOpenAddFundingSource);
  };

  const toggleEditFundingSource = () => {
    setIsOpenEditFundingSource(!isOpenEditFundingSource);
  };

  const openEditModal = async (values) => {
    setTargetedFundingSource(values);
    toggleEditFundingSource();
  };
  const handleFundingSourceCreate = async (values) => {
    try {
      await axios.post(`/client/${clientId}/case/${data.id}/casegrants`, {
        ...values,
        amount: values.amount && String(values.amount).replace(/[^0-9.]/g, ''),
      });
      setIsOpenAddFundingSource(false);
      successRefetch(refetch);
    } catch (error) {
      Alert.error(ERR_MSG);
    }
  };

  const handleFundingSourceEdit = async (values) => {
    try {
      await axios.put(
        `/client/${clientId}/case/${data.id}/casegrants/${values.id}`,
        {
          ...values,
          amount:
            values.amount && String(values.amount).replace(/[^0-9.]/g, ''),
        },
      );
      setIsOpenEditFundingSource(false);
      successRefetch(refetch);
    } catch (error) {
      Alert.error(ERR_MSG);
    }
  };

  const handleDeleteFundingSource = async (id) => {
    try {
      await axios.delete(
        `/client/${clientId}/case/${data.id}/casegrants/${id}`,
      );
      successRefetch(refetch);
    } catch (error) {
      Alert.error(ERR_MSG);
    }
  };
  return (
    <Card mt={20}>
      <TableCardHeader
        name="Funding Sources"
        action="Add Source"
        onClick={toggleAddFundingSource}
        disabled={!canEdit}
      />
      <TableBody maxHeight="15rem">
        <Table
          data={data.case_grants.map((item) => ({
            ...item,
            handleDeleteFundingSource,
            toggleEditFundingSource,
            openEditModal,
            canEdit,
          }))}
          columns={GRANT_SOURCES_COLUMNS}
        />
      </TableBody>
      <ModalForm
        title="Add Funding Source"
        isOpen={isOpenAddFundingSource}
        onSubmit={handleFundingSourceCreate}
        onClose={toggleAddFundingSource}
        fields={GRANT_SOURCES_MODAL_FIELDS}
        oneColumn
      />
      <ModalForm
        title="Edit Funding Source"
        isOpen={isOpenEditFundingSource}
        onSubmit={handleFundingSourceEdit}
        onClose={toggleEditFundingSource}
        fields={GRANT_SOURCES_MODAL_FIELDS}
        oneColumn
        initialValues={targetedFundingSource}
      />
    </Card>
  );
};

export default FundingSources;
